import { createAction, createActionGroup, emptyProps, props } from "@ngrx/store";
import { Auth } from "../../auth/primitives/auth";
import { Vector2, Vector3 } from "three";

export const cameraActions = createActionGroup({
  source: "Camera",
  events: {
    "Init Camera": props<{ target: Vector3 }>(),
    "Rewind Target": emptyProps(),
    "Pop Checkpoint History": emptyProps(),
    "Add Rewind Checkpoint Target": props<{ target: Vector3 }>(),
    "Target Moved": props<{ target: Vector3 }>(),
    "Target Jumped": props<{ target: Vector3, jumpTimeMs?: number, skipCheckpoint?: boolean}>(),
    "Zoom Changed": props<{ absoluteZoom: number }>(),
    "Zoom Jumped": props<{ absoluteZoom: number, jumpTimeMs?: number }>(),
    "Toggle Tracking": props<{ enabled: boolean }>(),
    "Toggle Map Mode": props<{ enabled: boolean }>(),
    "Triggered Canvas Resize Animation": props<{ durationMs: number }>(),
  },
});
